import React from "react";
import {
  NotificationsOutlined,
  Brightness4,
  AutoAwesome,
  Person,
  HelpOutline,
  ReceiptLongOutlined,
  AdminPanelSettings,
  Logout,
} from "@mui/icons-material";

/**
 * Definições do Topbar para uso em guias (ex.: /help).
 * Não controla renderização do Topbar — é apenas um “mapa” com ordem e gating.
 */
export const topbarHelpItems = [
  {
    key: "notifications",
    label: "Notificações",
    icon: <NotificationsOutlined />,
    kind: "action",
    visible: () => true,
  },
  {
    key: "themes",
    label: "Temas (aparência)",
    icon: <Brightness4 />,
    kind: "action",
    visible: () => true,
  },
  {
    key: "platform_ai",
    label: "Assistente da plataforma (IA)",
    icon: <AutoAwesome />,
    kind: "action",
    visible: () => true,
  },
  {
    key: "profile_menu",
    label: "Menu do perfil",
    icon: <Person />,
    kind: "group",
    visible: () => true,
    children: [
      {
        key: "my_profile",
        label: "Meu perfil",
        icon: <Person fontSize="small" />,
        kind: "route",
        route: "/profile",
        visible: () => true,
      },
      {
        key: "help_training",
        label: "Ajuda e Treinamento",
        icon: <HelpOutline fontSize="small" />,
        kind: "action",
        visible: () => true,
      },
      {
        key: "billing",
        label: "Plano e faturamento",
        icon: <ReceiptLongOutlined fontSize="small" />,
        kind: "route",
        route: "/settings/billing",
        visible: ({ canViewBilling }) => Boolean(canViewBilling),
      },
      {
        key: "platform_console",
        label: "Console da plataforma",
        icon: <AdminPanelSettings fontSize="small" />,
        kind: "route",
        route: "/platform/xprobase",
        visible: ({ isMasterUser }) => Boolean(isMasterUser),
      },
      {
        key: "logout",
        label: "Sair",
        icon: <Logout fontSize="small" />,
        kind: "action",
        visible: () => true,
      },
    ],
  },
];

